<div class="modal-header">
    <h5 class="modal-title text-center ml-auto mr-auto">{{ 'select_queue' | translate: lang }}</h5>
    <button (click)="modalService.closeOutletModals('public')" type="button" class="close" data-dismiss="modal" aria-label="Close">
        <svg-selector [svgName]="'close-small'" [svgColor]="'#ffffff'"></svg-selector>
    </button>
</div>
<div class="modal-body">
  <div *ngIf="game==='lol'" class="elems">
    <div class="elem" (click)="onSelect('soloq')">
      <img src="https://cdn.ggboost.com/images/icons/icon-solo-white.webp" alt="">
      <p class="text-mon mt-2 text-center">Solo/Duo</p>
    </div>
    <div class="elem" (click)="onSelect('flexq')">
      <img src="https://cdn.ggboost.com/images/icons/icon-duo-white.webp" alt="">
      <p class="text-mon mt-2 text-center">Flex</p>
    </div>
  </div>
  <div *ngIf="game==='tft'" class="elems">
    <div class="elem" (click)="onSelect('soloq')">
      <img src="https://cdn.ggboost.com/images/services/lol/divisions.webp" alt="">
      <p class="text-mon mt-2 text-center">Ranked</p>
    </div>
    <div class="elem" (click)="onSelect('doubleup')">
      <img src="https://cdn.ggboost.com/images/tft/services/doubleup.webp" alt="">
      <p class="text-mon mt-2 text-center">Double Up</p>
    </div>
  </div>
  <div *ngIf="game==='cs2'" class="elems">
    <div class="elem" (click)="onSelect('premier')">
      <img src="https://cdn.ggboost.com/images/cs2/icons/premier.webp" alt="">
      <p class="text-mon mt-2 text-center">Premier</p>
    </div>
    <div class="elem" (click)="onSelect('competitive')">
      <img src="https://cdn.ggboost.com/images/cs2/icons/competitive.webp" alt="">
      <p class="text-mon mt-2 text-center">Competitive</p>
    </div>
  </div>
  <div *ngIf="game==='overwatch'" class="elems">
    <div class="elem" (click)="onSelect('tank')">
      <img width="70" src="https://cdn.ggboost.com/images/roles/overwatch/tank.webp" alt="">
      <p class="text-mon mt-2 text-center underline-animation">Tank</p>
    </div>
    <div class="elem" (click)="onSelect('damage')">
      <img width="70" src="https://cdn.ggboost.com/images/roles/overwatch/damage.webp" alt="">
      <p class="text-mon mt-2 text-center underline-animation">Damage</p>
    </div>
    <div class="elem" (click)="onSelect('support')">
      <img width="70" src="https://cdn.ggboost.com/images/roles/overwatch/support.webp" alt="">
      <p class="text-mon mt-2 text-center underline-animation">Support</p>
    </div>
    <div class="vertical-line"></div>
    <div class="elem" (click)="onSelect('open')">
      <img width="70" src="https://cdn.ggboost.com/images/roles/overwatch/openq.webp" alt="">
      <p class="text-mon mt-2 text-center underline-animation">Open Queue</p>
    </div>
  </div>
</div>
